import axios from '@/axiosInterceptor';

const state = () => ({
  legalAgreements: [],
  consentLegalAgreements: [],
});

const getters = {};

const actions = {
  async getActiveLegalAgreements({ commit }, { types }) {
    try {
      const typesArray = Array.isArray(types) ? types : [types];
      const typeParams = typesArray
        .filter(Boolean)
        .map((type) => `q[is_type_in][]=${type}`)
        .join('&');

      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/legal_agreements?${typeParams}`
      );
      commit('setLegalAgreements', res.data);
    } catch (e) {
      if (axios.isAxiosError(e) && [401, 403].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async consentLegalAgreements({ commit }, { legalAgreementIds }) {
    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/consent_legal_agreements`,
        { legal_agreement_ids: legalAgreementIds }
      );
      commit('setConsentLegalAgreements', res.data);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [401, 403].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

const mutations = {
  setLegalAgreements(state, data) {
    state.legalAgreements = data;
  },
  setConsentLegalAgreements(state, data) {
    state.consentLegalAgreements = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
